import { InjectionToken } from '@angular/core';

export interface ClientData {
  name: string;
  supportedLanguages: [];
  smartSearchIds: number[];
  downloadCollectionCategoryIds: number[];
}

export const CLIENT_DATA = new InjectionToken<ClientData>('CLIENT_DATA_TOKEN');
